import React from "react";
import { cn } from "lib/utils";

export const cesuRadioGroupClassName = "group/cesu-option w-full";

export const cesuRadioLabelClassName = cn(
    "flex w-full cursor-pointer items-start justify-between gap-4 rounded-[22px] border border-input bg-background p-6 text-left transition-colors",
    "hover:border-primary/40",
    "group-has-[:checked]/cesu-option:border-primary group-has-[:checked]/cesu-option:bg-primary/5",
    "group-has-[:checked]/cesu-option:ring-2 group-has-[:checked]/cesu-option:ring-primary/20",
);

const iconClassName = cn(
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-input bg-muted/40 text-muted-foreground",
    "group-has-[:checked]/cesu-option:border-primary group-has-[:checked]/cesu-option:bg-primary",
    "group-has-[:checked]/cesu-option:text-white",
);

const titleClassName = cn(
    "text-sm font-black text-foreground",
    "group-has-[:checked]/cesu-option:text-primary",
);

interface CesuRadioOptionLabelProps {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
}

const CesuRadioOptionLabel: React.FC<CesuRadioOptionLabelProps> = ({ icon, title, subtitle }) => (
    <div className="flex w-full items-start gap-4">
        <div className={iconClassName}>{icon}</div>
        <div className="flex-1">
            <p className={titleClassName}>{title}</p>
            <p className="mt-2 text-xs leading-relaxed text-muted-foreground">{subtitle}</p>
        </div>
    </div>
);

export default CesuRadioOptionLabel;
